import api from "./api/api";
import type {
  CompanyProfile,
  CompanyProfilePayload,
} from "@/types/companyProfile";

const EmpresaService = {
  minhasEmpresas: (token?: string) => {
    return api.get(`/new/empresas/minhas-empresas`, 
      token ? {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      } : undefined
    );
  },
  addEmpresa: async (payload: any) => {
    try {
      const res = await api.post(`/empresas`, payload);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  registerRecruiting: async (payload: any) => {
    try {
      const res = await api.post(`/empresas/public/register-recruiting`, payload, {
        headers: { withoutAuth: true },
      });
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  getEmpresas: async (page = 1, perPage = 10, search?: string) => {
    try {
      if (search) {
        const res = await api.get(
          `/empresas?page=${page}&perPage=${perPage}&s=${search}`
        );
        return res;
      } else {
        const res = await api.get(`/empresas?page=${page}&perPage=${perPage}`);
        return res;
      }
    } catch (error: any) {
      return error.response;
    }
  },
  getEmpresa: async (id: any) => {
    try {
      const res = await api.get(`/empresas/${id}`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  editEmpresa: async (id: number, payload: any) => {
    try {
      const res = await api.put(`/empresas/${id}`, payload);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  deleteEmpresa: async (id: any) => {
    try {
      const res = await api.delete(`/empresas/${id}`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  getCompanyProfileMe: async () => {
    try {
      const res = await api.get<{ data: CompanyProfile }>(
        `/empresas/profile/me`,
      );
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  updateCompanyProfileMe: async (payload: CompanyProfilePayload) => {
    try {
      const res = await api.put<{ data: CompanyProfile }>(
        `/empresas/profile/me`,
        payload,
      );
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  getPublicCompanyProfile: async (slug: string) => {
    try {
      const res = await api.get<{ data: CompanyProfile }>(
        `/public/empresas/${slug}`,
        {
          headers: { withoutAuth: true },
        },
      );
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  addProdutoEmpresa: async (payload: any) => {
    try {
      const res = await api.post(`/produtosSteakholder/valor`, payload);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  editProdutoEmpresa: async (payload: any, id_produto: any) => {
    try {
      const res = await api.put(
        `/produtosSteakholder/valor/${id_produto}`,
        payload
      );
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  deleteProdutoEmpresa: async (id_produto: any) => {
    try {
      const res = await api.delete(`/produtosSteakholder/valor/${id_produto}`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  getProdutoEmpresa: async () => {
    try {
      const res = await api.get(`/produtosSteakholder/valores`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  getFormatoEmpresa: async (id: string) => {
    try {
      const res = await api.get(`/formatosSteakholder/produto/${id}`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  addFormatoEmpresa: async (id: string, payload: any) => {
    try {
      const res = await api.post(
        `/formatosSteakholder/addFormato/produto/${id}`,
        payload
      );
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  editFormatoEmpresa: async (id: string, payload: any) => {
    try {
      const res = await api.put(`/formatosSteakholder/${id}`, payload);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  uploadFormatoImage: async (file: File) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      const res = await api.post(`/files/upload`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return res;
    } catch (error: any) {
      return error.response;
    }
  },

  //Controller
  getProdutoController: async (id_empresa: any) => {
    try {
      const res = await api.get(
        `/jornada-performace-produtos?empresa_id=${id_empresa}`
      );
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  addProdutoController: async (payload: any) => {
    try {
      const res = await api.post(`/jornada-performace-produtos`, payload);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  getCanaisController: async (produto_id: any) => {
    try {
      const res = await api.get(
        `/jornada-performace-canal?produto_id=${produto_id}`
      );
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  addCanaisController: async (payload: any) => {
    try {
      const res = await api.post(`/jornada-performace-canal`, payload);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  getFormatosController: async (canal_id: any) => {
    try {
      const res = await api.get(
        `/jornada-performace-formato?canal_id=${canal_id}`
      );
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  addFormatoController: async (payload: any) => {
    try {
      const res = await api.post(`/jornada-performace-formato`, payload);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  getModelosController: async (formato_id: any) => {
    try {
      const res = await api.get(
        `/jornada-performace-modelo?formato_id=${formato_id}`
      );
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  addModelosController: async (payload: any) => {
    try {
      const res = await api.post(`/jornada-performace-modelo`, payload);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  enableCreationNFe: async (id: any) => {
    try {
      const res = await api.post(`/empresas/nfe/habilitar/${id}`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },

  disableCreationNFe: async (id: any) => {
    try {
      const res = await api.delete(`/empresas/nfe/desabilitar/${id}`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
};

export default EmpresaService;
